export default "__VITE_ASSET__m1k3sDb8__"